import {Module} from '@dms/api/shared';
import {moduleKeys} from '@dms/config';
import {featureFlags} from '@dms/feature-flags';
import {myProfileRoutes} from '@dms/routes';
import {permissions} from '@dms/shared';

import {CalendarSynchronization} from './pages/CalendarSynchronization/CalendarSynchronization';
import {Dashboard} from './pages/Dashboard/Dashboard';
import {EmailServices} from './pages/EmailServices/EmailServices';
import {EmailSignature} from './pages/EmailSignature/EmailSignature';
import {ExternalSystems} from './pages/ExternalSystems/ExternalSystems';
import {Language} from './pages/Language/Language';
import {MultiFactorAuthentication} from './pages/MultiFactorAuthentication/MultiFactorAuthentication';
import {NotificationDetail} from './pages/NotificationDetail/NotificationDetail';
import {NotificationOverview} from './pages/NotificationOverview/NotificationOverview';
import {PersonalInformation} from './pages/PersonalInformation/PersonalInformation';
import {Security} from './pages/Security/Security';
import {MyProfileModuleProps} from './types/MyProfileModuleProps';

export const MyProfileModule = (props: MyProfileModuleProps): Module => ({
  id: moduleKeys.myProfile,
  routerProps: {
    path: myProfileRoutes.personalInformation,
    element: <PersonalInformation />,
  },
  content: [
    {
      id: 'my-profile-personal-information',
      routerProps: {
        path: myProfileRoutes.personalInformation,
        element: <PersonalInformation />,
      },
    },
    {
      id: 'my-profile-security',
      routerProps: {
        path: myProfileRoutes.security,
        element: <Security />,
      },
    },
    {
      id: 'my-profile-dashboard',
      routerProps: {
        path: myProfileRoutes.dashboard,
        element: <Dashboard />,
      },
    },
    {
      id: 'my-profile-language',
      routerProps: {
        path: myProfileRoutes.language,
        element: <Language purge={props.purge} />,
      },
    },
    {
      id: 'my-profile-notification',
      routerProps: {
        path: myProfileRoutes.notifications,
        element: <NotificationOverview />,
      },
    },
    {
      id: 'my-profile-email-services',
      routerProps: {
        path: myProfileRoutes.emailServices,
        element: <EmailServices />,
      },
    },
    {
      id: 'my-profile-notification-detail',
      routerProps: {
        path: myProfileRoutes.notificationDetail,
        element: <NotificationDetail />,
      },
    },
    {
      id: 'my-profile-email-signature',
      routerProps: {
        path: myProfileRoutes.emailSignature,
        element: <EmailSignature />,
      },
    },
    {
      id: 'my-profile-external-systems',
      routerProps: {
        path: myProfileRoutes.externalSystems,
        element: <ExternalSystems />,
      },
    },
    {
      id: 'my-profile-multi-factor-authentication',
      routerProps: {
        path: myProfileRoutes.multiFactorAuthentication,
        element: <MultiFactorAuthentication />,
      },
      requiredPermission: permissions.canReadUserMultiFactorAuthenticationSettings,
    },
    {
      id: 'my-profile-calendar-synchronization',
      routerProps: {
        path: myProfileRoutes.calendarSynchronization,
        element: <CalendarSynchronization />,
      },
      requiredFeatureFlag: featureFlags.OUTLOOK_INTEGRATION,
    },
  ],
});
